<template>
  <!-- Footer Section Start -->
  <footer>
      <!-- Footer Area Start -->
      <section class="footer-Content">
        <div class="container">
          <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6 col-mb-12">
              <div class="widget">
                <h3 class="block-title" style="color: #fff">Iniciativa</h3>
                <div class="textwidget" style="text-align: justify">
                  <p>A plataforma Crescimento Conectado faz parte da...</p>
                </div>
              </div>
            </div>
            <div class="col-lg-1 col-md-6 col-sm-6 col-xs-6 col-mb-12">
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6 col-xs-6 col-mb-12">
            </div>
            <div class="col-lg-1 col-md-6 col-sm-6 col-xs-6 col-mb-12">
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-mb-12">
              <div class="widget">
                <h3 class="block-title" style="color: #fff">Contato</h3>
                <ul class="contact-footer">
                  <li>
                    <a href="https://api.whatsapp.com/send?1=pt_BR&phone=8300000000" style="color: #fff; font-size: 16px"><strong><i class="lni-phone-handset"></i>&nbsp;&nbsp;Falar pelo WhatsApp</strong></a>
                  </li>
                  <li>
                    <a href="https://instagram.com/crescimentoconectado" style="color: #fff; font-size: 16px"><strong><i class="lni-instagram"></i>&nbsp;&nbsp;Siga-nos no Instagram</strong></a>
                  </li>
                </ul>
                <br/>
                <!-- <a style="color: #fff" href="#" id="btnPrivac2" data-target="#modalPrivacidade" data-toggle="modal" data-bs-target="#modalPrivacidade"><strong>Política de Privacidade</strong></a>
                <br/>
                <a style="color: #fff" href="#" id="btnTermos2" data-target="#modalTermos" data-toggle="modal" data-bs-target="#modalTermos"><strong>Termos de uso</strong></a> -->       
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Footer area End -->
      
      <!-- Copyright Start  -->
      <div id="copyright">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="site-info float-left">
                <p style="color: white; font-size: 14px;">Copyright © &nbsp;&nbsp;
                    <a href="https://fapesq.rpp.br/" target="_blank"><img src="assets/img/fapesq.png" alt="logo"></a>
                    <br><br>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Copyright End -->

  </footer>
  <!-- Footer Section End --> 

  <!-- Go to Top Link -->
  <a href="#" class="back-to-top">
    <i class="lni-chevron-up"></i>
  </a>

</template>

<script>
  export default {
    name: "Footer" 
  }
</script>
